import { render, staticRenderFns } from "./parameters.vue?vue&type=template&id=e740b636&scoped=true&"
import script from "./parameters.vue?vue&type=script&lang=js&"
export * from "./parameters.vue?vue&type=script&lang=js&"
import style0 from "./parameters.vue?vue&type=style&index=0&id=e740b636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e740b636",
  null
  
)

export default component.exports